import React from "react";
import { Form } from "react-bootstrap";
import styles from "./MasterData.module.scss";

export type MasterSelectOption = {
  value: string | number;
  label: string;
};

type MasterSelectProps = {
  name?: string;
  value: string | number;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  options: MasterSelectOption[];
  placeholder?: string;
  required?: boolean;
  label?: string;
  invalidMessage?: string;
  toolbar?: boolean;
};

const SelectControl = Form.Select as React.ComponentType<any>;

export default function MasterSelect({
  name,
  value,
  onChange,
  options,
  placeholder,
  required = false,
  label,
  invalidMessage,
  toolbar = false,
}: MasterSelectProps) {
  const control = (
    <>
      <SelectControl
        required={required}
        size="sm"
        name={name}
        value={value}
        onChange={onChange}
        className={toolbar ? styles.toolbarSelect : undefined}
      >
        {placeholder ? <option value="">{placeholder}</option> : null}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </SelectControl>
      {invalidMessage ? (
        <Form.Control.Feedback type="invalid">{invalidMessage}</Form.Control.Feedback>
      ) : null}
    </>
  );

  if (!label) return control;

  return (
    <Form.Group>
      <Form.Label>{label}</Form.Label>
      {control}
    </Form.Group>
  );
}
